class TranslationLoader {
    constructor($q, language) {
        this.language = language;
        this.$q = $q;
    }

    ensureTranslations(domain) {
        var def = this.$q.defer();
        var lang = this.language.getCurrentLanguage();

        require.ensure([], () => {
            require(
                'imports-loader?Translator=exports%2Dloader%3FTranslator%21@BazingaJsTranslationBundle/Resources/public/js/translator.min.js'
                + '!@root/web/js/translations/' + domain + '/' + lang + '.js'
            );

            def.resolve();
        });

        return def.promise;
    }
}

TranslationLoader.$inject = ['$q', 'language'];

export default TranslationLoader;
